'use strict';

/* Views */
import BulletinArchive from './archive/bulletin-archive.component';
import BulletinEdit from './edit/bulletin-edit.component';

import BulletinListGeneral from './list/general/bulletin-list.component';
import BulletinListPublic from './list/public/bulletin-public.component';
import BulletinListRealtor from './list/realtor/bulletin-realtor.component';

import BulletinListView from './show/bulletin-show.component';

/* Components */
import BulletinPostComponent from '../../components/bulletin/post/BulletinPost.component';
import BulletinPropertyListComponent from '../../components/bulletin/property-list/bulletin-property-list.component';
import ReasonFormComponent from '../../components/reason-form/reason-form.component';

/* Services */
import BulletinService from '../../services/bulletin/bulletin.service';

export default angular.module('conduuApp.bulletin', [BulletinArchive, BulletinEdit, BulletinListGeneral, BulletinListPublic,
  BulletinListRealtor, BulletinListView, BulletinPostComponent, BulletinPropertyListComponent, ReasonFormComponent,
  BulletinService])
  .name;



// WEBPACK FOOTER //
// ./client/app/bulletin/index.js